import { render, staticRenderFns } from "./OnboardingCompletionButton.vue?vue&type=template&id=63c428c9&"
import script from "./OnboardingCompletionButton.vue?vue&type=script&lang=js&"
export * from "./OnboardingCompletionButton.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingCompletionButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports